import * as React from "react";
import { WalletListItem } from "@/services/backend";
import TruncateAddress from "@/components/utils/truncateAddress";
import CheckIcon from "./check-icon";
import MinusButton from "./minus-button";

interface WhitelistTableProps {
  whitelist: WalletListItem[];
  toggleSelect: (wallet: string) => void;
  selectedWallets?: Set<string>;
  showCheckbox?: boolean;
  showRemove?: boolean;
}

const WhitelistTable = ({
  whitelist,
  toggleSelect,
  selectedWallets = new Set(),
  showCheckbox,
  showRemove,
}: WhitelistTableProps) => {
  const handleClick = (wallet: string) => {
    console.log("clicked", wallet);
    toggleSelect(wallet);
  };

  const handleRemove = (wallet: string) => {
    console.log("removing", wallet);
    toggleSelect(wallet);
  };

  return (
    <div>
      {whitelist.map((list, index) => (
        <div
          key={index}
          className="flex items-center gap-2 text-[16px] font-spline-sans-mono py-[10px]"
        >
          {showCheckbox && (
            <div
              className={`relative w-[24px] h-[24px] pointer-events-auto cursor-pointer border-2 rounded-sm flex items-center justify-center transition-all duration-200 `}
              onClick={() => handleClick(list.wallet)}
            >
              {selectedWallets?.has(list.wallet) && (
                <CheckIcon
                  className="absolute left-[0px] top-[-7px] w-[31px] h-[28px]"
                  color="#FF0000"
                />
              )}
            </div>
          )}
          <span className="text-gray-500 w-[60px]">
            {String(index).padStart(6, "0")}
          </span>

          <TruncateAddress
            address={list.wallet}
            className={`${selectedWallets?.has(list.wallet) ? "text-primary-blue" : ""} truncate flex-1`}
          />
          {showRemove && (
            <MinusButton
              className="text-primary-red text-[20px] font-bold hover:cursor-pointer"
              color="#FF0000"
              onClick={() => handleRemove(list.wallet)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default WhitelistTable;
